import { useState, useEffect } from "react";
import versionData from "../version.json";

// custom hook to fetch version
export const useVersion = (defaultVersion = "develop-SNAPSHOT") => {
  const [version, setVersion] = useState(defaultVersion);

  useEffect(() => {
    const fetchVersion = async () => {
      try {
        const response = await fetch("version.json", {
          cache: "no-cache", // prevent cached versions during development
        });

        if (response.ok) {
          const data = await response.json();
          if (data?.version) {
            setVersion((data?.version && data.version !== "${project.version}") ? data.version : "develop-SNAPSHOT");
          }
        }
      } catch (error) {
        console.warn("Failed to fetch version.json. Using default version:", error);
      }
    };

    fetchVersion();
  }, []);

  return version;
};